/**
* Model import Example :
* import { HERO } from '../models/hero.model.ts';
*/
var wiccardviewComponent = (function () {
    function wiccardviewComponent() {
        this.wicData = {};
        this.padLeft = function (number) {
            if (number !== null && number !== undefined) {
                var str = '' + number;
                while (str.length < 2) {
                    str = '0' + str;
                }
                return str;
            }
        };
    }
    wiccardviewComponent.prototype.ngOnInit = function () {
        // console.log(this.wicData);
    };
    wiccardviewComponent.prototype.convertToTime = function (secs) {
        if (secs !== undefined && secs > 0) {
            var hours = Math.floor(secs / (60 * 60));
            var divisor_for_minutes = secs % (60 * 60);
            var minutes = Math.floor(divisor_for_minutes / 60);
            var divisor_for_seconds = divisor_for_minutes % 60;
            var seconds = Math.ceil(divisor_for_seconds);
            var time = this.padLeft(hours) + ':' + this.padLeft(minutes);
            return time;
        }
        else {
            return '00:00';
        }
    };
    wiccardviewComponent.prototype.checkTimeCategory = function (time, name) {
        var fiveMin = 300; // 5 * 60;
        var fifteenMin = 900; // 15 * 60;
        if (time || time == 0) {
            // time < 5min
            if (this.compareTime(time, fiveMin)) {
                return 'low';
            }
            else if (this.compareTime(fiveMin, time) && this.compareTime(time, fifteenMin)) {
                return 'medium';
            }
            else if (this.compareTime(fifteenMin, time)) {
                return 'high';
            }
        }
        return null;
    };
    wiccardviewComponent.prototype.compareTime = function (time1, time2) {
        if (time1 <= time2) {
            return true;
        }
        return false;
    };
    /**
     * Format numeric time to HH:MM:SS format
     * @param timeNum numeric number either in minutes or seconds to be formatted
     * @param option string value either 'seconds' or 'minutes'. Invalid option returns null.
     */
    wiccardviewComponent.prototype.formatToTime = function (timeNum, option) {
        var formattedTime = '';
        switch (option) {
            case 'secs':
                formattedTime = this.formatToSeconds(timeNum);
                break;
            case 'mins':
                formattedTime = this.formatToMinutes(timeNum);
                break;
            default:
                return null;
        }
        return formattedTime;
    };
    wiccardviewComponent.prototype.formatToSeconds = function (seconds) {
        var date = this.returnFirstDate();
        date.setSeconds(seconds);
        return this.returnTimeString(date);
    };
    wiccardviewComponent.prototype.formatToMinutes = function (minutes) {
        var date = this.returnFirstDate();
        date.setMinutes(minutes);
        return this.returnTimeString(date);
    };
    wiccardviewComponent.prototype.returnTimeString = function (dateString) {
        return dateString.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
    };
    wiccardviewComponent.prototype.returnFirstDate = function () {
        return new Date(1970, 0, 1);
    };
    return wiccardviewComponent;
}());
export { wiccardviewComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/wiccardviewComponent/wiccardview.component.ts.pre-build-optimizer.js